import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=4506ca44&scoped=true&"
import script from "./Audio.vue?vue&type=script&lang=js&"
export * from "./Audio.vue?vue&type=script&lang=js&"
import style0 from "./Audio.vue?vue&type=style&index=0&id=4506ca44&lang=stylus&scoped=true&"
import style1 from "./Audio.vue?vue&type=style&index=1&id=4506ca44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4506ca44",
  null
  
)

export default component.exports